import React from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  ArticlePartDatatable = (props) => {

    const [t] = useTranslation();     

    const tableName = t('articlePart.label.articleParts');     

    const columns = [       
             { name: "Id", data: "id", selector: "id", omit: true},
             { name: t('general.label.name'), data: "articlePart.name", sortable: true, selector: "articlePart.name", minWidth: '500px'},    		
             { name: t('articlePart.label.volume'), data: "volume", sortable: true, selector: "volume"},    		
             { name: t('article.label.measureUnit'), data: "articlePart.measureUnit",  sortable: true,  selector: "articlePart.measureUnit"},
             { name: t('partner.label.validFrom'), data: "validFrom", sortable: true,  selector: "validFrom"},
             { name: t('partner.label.validTo'), data: "validTo", sortable: true,  selector: "validTo"}                  
     ];        
 
 
         
     const columnsData = [       
         { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
         { name: t('general.label.name'), data: "articlePart.name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
         { name: t('articlePart.label.volume'), data: "volume", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('article.label.measureUnit'), data: "articlePart.measureUnit", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('partner.label.validFrom'), data: "validFrom", orderable: true,  searchable: true, search: {value: '',regex: false}},                 
         { name: t('partner.label.validTo'), data: "validTo", orderable: true,  searchable: true, search: {value: '',regex: false}}                 
     ];        
     const url = RestService.getBaseURL()+"article/getArticlePartsList?id="+props.entityId;   
     const urlExcel = RestService.getBaseURL()+"";          
    
   
 

     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   
          
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={false}
             />
           
         );
    
 
  
 };

export default ArticlePartDatatable;

